export const CWD_CHANGED = 'tree/CWD_CHANGED';
export const ADD_FOLDER_REQUESTED = 'tree/ADD_FOLDER_REQUESTED';
export const ADD_FOLDER_REQUEST_FULFILLED = 'tree/ADD_FOLDER_REQUEST_FULFILLED';
export const ADD_FOLDER_REQUEST_REJECTED = 'tree/ADD_FOLDER_REQUEST_REJECTED';
export const GET_FOLDER_REQUESTED = 'tree/GET_FOLDER_REQUESTED';
export const GET_FOLDER_REQUEST_FULFILLED = 'tree/GET_FOLDER_REQUEST_FULFILLED';
export const GET_FOLDER_REQUEST_REJECTED = 'tree/GET_FOLDER_REQUEST_REJECTED';
export const UPDATE_FOLDER_REQUEST_FULFILLED = 'tree/UPDATE_FOLDER_REQUEST_FULFILLED';
export const DELETE_CONTENT_OR_FOLDER_SUCCESS = 'tree/DELETE_CONTENT_OR_FOLDER_SUCCESS';

export const MENU_ACTION_DELETE = { text: 'Delete', action: 'DELETE' };
export const MENU_ACTION_DELETE_PAGE = { text: 'Delete', action: 'DELETE_PAGE' };
export const MENU_ACTION_MOVE = { text: 'Move', action: 'MOVE' };
export const MENU_ACTION_RENAME = { text: 'Rename', action: 'RENAME' };
export const MENU_ACTION_DUPLICATE = { text: 'Copy', action: 'DUPLICATE' };

export const MENU_ACTION_UNFAVORITE = { text: 'Unfavorite', action: 'UNFAVORITE' };
export const MENU_ACTION_FAVORITE = { text: 'Favorite', action: 'FAVORITE' };

export const PAGE_MENU_EDITOR_ACTIONS = [
  MENU_ACTION_MOVE,
  MENU_ACTION_DUPLICATE,
  MENU_ACTION_DELETE_PAGE
];

export const FOLDER_MENU_EDITOR_ACTIONS = [
  MENU_ACTION_RENAME,
  MENU_ACTION_MOVE,
  MENU_ACTION_DELETE
];
